import { SettingsRateChartPrivate, SettingsRatechartsService } from "../client"

/* Interfaces */
export interface RatechartsProps {
  onClose: () => void
  isOpen: boolean
  ratechart: SettingsRateChartPrivate
}

export interface AddSettingsRatechartProps {
    onClose: () => void
    isOpen: boolean
}


/* Endpoints */
export const readRatecharts = () => {
    return {
        queryFn: async () => {
            const data = await SettingsRatechartsService.readSettingsRatecharts()
            return data ?? { data: null, count: 0 }
        },
        queryKey: ["settings-ratecharts"],
    }
}
